import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import { UnstyledButton } from "@sportal/cdk/unstyledButton/UnstyledButton";
import { useIntlTranslate } from "../../../hooks";
import { Icon } from "../../icon/Icon";

import "./ListItem.scss";

export const ListItem = ({
  className,
  item,
  icon,
  onRemove,
  children,
  dataId,
  name,
}) => {
  const translate = useIntlTranslate();

  return (
    <li className={classnames("list-item", className)} data-id={dataId}>
      <Icon icon={classnames("list-item__icon", "fa-regular", "fa-fw", icon)} />
      <div className="list-item__content">{children}</div>
      <UnstyledButton
        onClick={() => onRemove(item)}
        className={classnames(
          "list-item__remove-link",
          className && `${className}__remove-link`
        )}
        aria-label={translate("aria_remove_domain_from_the_list", {
          list: name,
        })}
      >
        <Icon icon="fa-light fa-times list-item__remove-icon" />
      </UnstyledButton>
    </li>
  );
};

ListItem.propTypes = {
  item: PropTypes.any.isRequired,
  icon: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired,
  dataId: PropTypes.string, // For testing
};
